import { render, staticRenderFns } from "./PaymentWithContentCategory.vue?vue&type=template&id=491f2245&"
import script from "./PaymentWithContentCategory.vue?vue&type=script&lang=js&"
export * from "./PaymentWithContentCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports